import TransactionAmount from '@/generated/controls/transaction/TransactionAmount.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: TransactionAmount
})